import NonTrialInactiveSubscriptionPageGuard from './NonTrialInactiveSubscriptionPageGuard';

export default NonTrialInactiveSubscriptionPageGuard;
